import { useDispatch, useSelector } from 'react-redux';
import { Node } from '../../models/models';
import { openDialog } from '../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../store/dialog/dialog.types';
import {
    changeNodeStatusStart,
    getNodeStart,
} from '../../store/node/node.action';
import { selectNodeSelected } from '../../store/node/node.selector';
import { getProjectStart } from '../../store/project/project.action';
import {
    selectNodeProjectSelected,
    selectProjectSelected,
} from '../../store/project/project.selector';
import {
    canPutNodeInDoneOrActive,
    canPutNodeInReview,
} from '../../utils/role/role.utils';

const NodeButton = ({ node }: { node: Node }) => {
    const nodeSelected = useSelector(selectNodeSelected);
    const nodeProjectSelected = useSelector(selectNodeProjectSelected);
    const projectSelected = useSelector(selectProjectSelected);
    const dispatch = useDispatch();

    const handleReviewOrDoneClick = () => {
        if (canPutNodeInReview(node)) {
            const status = 'in_review';
            dispatch(
                changeNodeStatusStart(node.id, status, [], () => {
                    dispatch(getNodeStart(nodeSelected!.id));
                    if (nodeProjectSelected) {
                        dispatch(
                            getProjectStart(nodeProjectSelected.id, node.id)
                        );
                    } else if (projectSelected) {
                        dispatch(getProjectStart(projectSelected.id, node.id));
                    }
                })
            );
        } else if (canPutNodeInDoneOrActive(node)) {
            if (
                node.refused_attachments_count > 0 ||
                node.replaced_attachments_count > 0 ||
                node.active_attachments_count > 0
            ) {
                dispatch(openDialog(DIALOG_TYPES.COMPLETE_NODE, { node }));
            } else {
                dispatch(openDialog(DIALOG_TYPES.NEXT_STEP_NODE, { node }));
            }
        }
    };

    const shouldShowButton =
        canPutNodeInReview(node) || canPutNodeInDoneOrActive(node);

    if (!shouldShowButton) return null;

    return (
        <button
            onClick={handleReviewOrDoneClick}
            style={{
                borderRadius: '15px',
                background: '#59B8CA',
                width: '220px',
                height: '40px',
                flexShrink: 0,
                color: '#2C375A',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
            }}
        >
            {canPutNodeInReview(node) ? 'MANDA IN REVISIONE' : 'COMPLETA'}
        </button>
    );
};

export default NodeButton;
